// Library
import Icon from "../Icon/Icon";

export default function BelievemyHR(props) {
    return (
        <div
            className={`${props.my ? props.my : "my-10"} ${
                !props.withoutMax && "max-w-xl"
            } mx-auto ${props.className}`}
        >
            <div
                className="bg-black/30 dark:bg-bgDark-550"
                style={{ height: 1 }}
            ></div>
            <div className="flex justify-center">
                <div
                    className={`inline-flex justify-center ${
                        props.backgroundLightMode
                            ? props.backgroundLightMode
                            : "bg-white"
                    } ${
                        props.backgroundDarkMode
                            ? props.backgroundDarkMode
                            : "dark:bg-bgDark-700"
                    }
                     p-3 transform -translate-y-1/2`}
                >
                    <div className="block dark:hidden">
                        <Icon ratio={0.017} outline />
                    </div>
                    <div className="hidden dark:block">
                        <Icon ratio={0.017} white outline />
                    </div>
                </div>
            </div>
        </div>
    );
}
